import { Link } from 'react-router';
import AsciiArt from '../components/AsciiArt';
import useDocumentMeta from '../hooks/useDocumentMeta';
import useMediaQuery from '../hooks/useMediaQuery';
import { asciiPortrait } from '../data/asciiPortrait';
import { about, contactMethods, pageMeta, site } from '../data/site';
import styles from './Home.module.scss';

/**
 * The width at which the hero splits into two columns. Mirrors the breakpoint in
 * Home.module.scss — below it there is no second column for the portrait to sit
 * in, so it is left out of the tree entirely rather than hidden with CSS. That
 * skips the settle animation and its per-frame string building on phones, where
 * there is no cursor to drive the effect anyway.
 */
const HERO_SPLIT = '(min-width: 56rem)';

function Home() {
  useDocumentMeta(pageMeta['/']);

  const showPortrait = useMediaQuery(HERO_SPLIT);
  const email = contactMethods.find((method) => method.id === 'email');

  return (
    <article className={styles.hero}>
      <div className={styles.intro}>
        <p className={styles.eyebrow}>{about.eyebrow}</p>
        <h1 className={styles.title}>{about.title}</h1>
        <p className={styles.lead}>{about.lead}</p>

        <div className={styles.body}>
          {about.body.map((paragraph) => (
            <p key={paragraph.slice(0, 32)}>{paragraph}</p>
          ))}
        </div>

        <div className={styles.actions}>
          <Link to="/work" className={styles.actionPrimary}>
            View work
          </Link>
          <a href={email.href} className={styles.actionSecondary}>
            {email.value}
          </a>
        </div>
      </div>

      {showPortrait && (
        <div className={styles.aside}>
          <AsciiArt
            grid={asciiPortrait}
            label={`${site.name}, drawn as a grid of text characters`}
          />
        </div>
      )}
    </article>
  );
}

export default Home;
